module.exports = __webpack_public_path__ + "media/images/voice12-2-e1d3c357552f5a2e07749a94cb2fcbea.jpg";